import { ChipOverflowObserver } from './ChipOverflowObserver';

export function observeChipOverflow(ref: any, dotNetRef: any) {
    let observer = new ChipOverflowObserver();
    observer.observe(ref, dotNetRef);
    return {
        unobserve: () => observer.dispose()
    };
}
